export default __webpack_public_path__ + "static/media/Kitty Moore.4d46dd0d.jpg";